import { render, staticRenderFns } from "./PrintCard.vue?vue&type=template&id=c4da67f0&scoped=true"
import script from "./PrintCard.vue?vue&type=script&lang=ts"
export * from "./PrintCard.vue?vue&type=script&lang=ts"
import style0 from "./PrintCard.vue?vue&type=style&index=0&id=c4da67f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4da67f0",
  null
  
)

export default component.exports